<div class="container-fluid">
    <app-frame [frameSrc]="url" frameType="custom" id="CUSTOMERAGENT"></app-frame>
</div>
